'use strict';
{
    var app = angular.module('tf.tradingTools', [])
        .controller('tradingToolsCtrl', ['$scope', '$state',  '$resource', 'uiGridConstants', 'uiGridExporterConstants', '$http', 'csv', '$sanitize', '$aside', function supportController($scope, $state, $resource, uiGridConstants, uiGridExporterConstants, $http, csv, $sanitize, $aside) {
            // outliers: [20, 30, 32]

            //showxaxis="true"
            //yaxishighlightzero="false"
            //xaxishighlightzero="false"
            //showyaxis="true"
            //staggerlabels="true"
            //showlegend="false"
            //tooltips="true"
            //stacked="true"
            //transitionduration="750"
            //height="450"
            //x="x()"
            //y="y()"
            //yaxistickformat="yaxistickformat()"
            //margin="{left:90,top:10,bottom:50,right:10}"

            $scope.options = {
                chart: {
                    type: 'multiBarChart',
                    height: 450,
                    margin : {
                        top: 20,
                        right: 20,
                        bottom: 65,
                        left: 70
                    },
                    x : function(d) {
                        if ($scope.chartType == 'overview') {
                            return d.data.sectorName;
                        } else {
                            return d.data.underlying;
                        }
                    },
                    y : function(d, series) {
                        return d.value;
                    },
                    showValues: true,
                    duration: 100,
                    xAxis: {
                        axisLabel: 'Sector',
                        showMaxMin: false
                    },
                    yAxis: {
                        axisLabel: 'Y Axis',
                        axisLabelDistance: -10
                    },
                    zoom: {
                        enabled: true,
                        scaleExtent: [1, 10],
                        useFixedDomain: false,
                        useNiceScale: false,
                        horizontalOff: false,
                        verticalOff: true,
                        unzoomEventType: 'dblclick.zoom'
                    }
                }
            };

            $scope.availableSectors = [];
            $scope.underlyings = [];
            $scope.sectors = {};
            $scope.chartType = 'overview';

            $scope.openInterestChartData = [
                {
                    key : "Put",
                    values : []
                },
                {
                    key : "Call",
                    values : []
                }

            ];



            $scope.$on('elementClick.directive', function (angularEvent, event) {
                var sector = event.point.data.sector;

                if ($scope.chartType == 'overview') {
                    if (sector) {
                        $scope.showChart('sector', sector);
                    } else {
                        $scope.showChart('underlying')
                    }
                } else {
                    $scope.showChart('overview');
                }

                $scope.$apply();
            });

            //            GRID

            var data = [];

            $scope.gridOptionsStockSearch = {
                enableFiltering: true,
                minRowsToShow : 10,
                enablePaging : false,
                excessRows : 20,

                columnDefs: [
                    { field: 'Stock', displayName:'Stock', width:'*' },
                    { field: 'Last', displayName:'Last', width:'*'},
                    { field: '52-wk Range', displayName:'52-wk Range', width:'*'},
                    { field: '52-wk High', displayName:'52-wk High', width:'*'},
                    { field: '52-wk Low', displayName:'52-wk Low', width:'*'},
                    { field: 'percentage52wk', displayName:'percentage52wk', width:'*'},
                    { field: 'P/E', displayName:'P/E', width:'*'},
                    { field: 'Beta', displayName:'Beta', width:'*'},
                    { field: 'IV', displayName:'Implied Volatility', width:'*'},
                    { field: 'HV', displayName:'Historical Volatility', width:'*'},

                    { field: 'IV/HV', displayName:'IV/HV', width:'*'}
                ],
            //{ field: '30d Range', displayName:'30d Range', width:'*'},
            //{ field: 'percentage30d', displayName:'percentage30d', width:'*'},
            //{ field: '30d High', displayName:'30d High', width:'*'},
            //{ field: '30d Low', displayName:'30d Low', width:'*'},
            //{ field: 'HV_10', displayName:'HV(10)', width:'*'},
            //{ field: 'HV_30', displayName:'HV(30)', width:'*'},
            //{ field: 'HV_90', displayName:'HV(90)', width:'*'},

                onRegisterApi: function(gridApi){
                    $scope.gridApi = gridApi;

                },

                data: data

            };

            $http.get('app/wizard/trading-tools/tradingToolsSteps/stock/stock.json')
                .then(function(response) {
                    var data = response.data;
                    $scope.gridOptionsStockSearch.data = data;
                });


            $scope.openTablePrefs = function() {
                var position = 'right';
                var backdrop = true;

                $scope.asideState = {
                    open: true,
                    position: position
                };

                $aside.open({
                    templateUrl: 'app/layout/tablePrefs/openPosPref.html',
                    placement: position,
                    size: 'sm',
                    backdrop: backdrop,
                    controller : 'TablePrefCtrl',
                    resolve : {
                        gridApi : function() {
                            return $scope.gridApi;
                        }
                    }

                });
            };

            $http.get('/tradefloor/api/open_interest/overnight', {}).then(function(response) {
                var data = response.data;

                $scope.underlyings = [];
                $scope.sectors = {};

                angular.forEach(data.underlyings, function (interest) {

                    if (interest.underlying != 'XJO' && interest.sector != '00' && interest.sector != '99') {

                        $scope.underlyings.push(interest);

                        var sector = $scope.sectors[interest.sector];
                        if (sector == null) {
                            sector = {
                                sector : interest.sector,
                                sectorName : sectorName(interest.sector),
                                puts : 0,
                                calls : 0,
                                weightedPuts : 0,
                                weightedCalls : 0,
                                net : 0
                            };
                            $scope.sectors[interest.sector] = sector;
                        }

                        sector.puts += interest.puts;
                        sector.calls += interest.calls;
                        sector.weightedPuts += interest.weightedPuts;
                        sector.weightedCalls += interest.weightedCalls;
                        sector.net += interest.net;
                    }

                    if (interest.underlying == 'XJO') {
                        $scope.sectors['Index'] = {
                            sectorName : 'Index',
                            puts : interest.puts,
                            calls : interest.calls,
                            weightedPuts : interest.weightedPuts,
                            weightedCalls : interest.weightedCalls,
                            net : interest.net
                        };
                    }
                });

                $scope.underlyings = $scope.underlyings.sort(function (a, b) {
                    if (a.underlying < b.underlying) {
                        return -1;
                    } else if (a.underlying > b.underlying) {
                        return 1;
                    }
                    return 0;
                });

                $scope.showChart('overview');

            });

            $scope.showChart = function(chartType, param) {
                $scope.chartType = chartType;

                var puts = [];
                var calls = [];

                if (chartType == 'overview') {

                    var sectorNames = Object.keys($scope.sectors);

                    for (var i = 0; i < sectorNames.length; i++) {
                        var sector = $scope.sectors[sectorNames[i]];
                        puts.push({
                            value: sector.weightedPuts,
                            data: sector
                        });
                        calls.push({
                            value: sector.weightedCalls,
                            data: sector
                        });
                    }
                } else if (chartType == 'sector') {
                    $scope.selectedSector = param;
                    $scope.selectedSectorName = sectorName(param);

                    var underlyingsInSector = $scope.underlyings.filter(function(value) {
                        return value.sector == $scope.selectedSector;
                    });

                    for (var i = 0; i < underlyingsInSector.length; i++) {
                        var underlying = underlyingsInSector[i];
                        puts.push({
                            value: underlying.weightedPuts,
                            data: underlying
                        });
                        calls.push({
                            value: underlying.weightedCalls,
                            data: underlying
                        });
                    }
                } else {
                    for (var i = 0; i < $scope.underlyings.length; i++) {
                        var underlying = $scope.underlyings[i];
                        puts.push({
                            value: underlying.weightedPuts,
                            data: underlying
                        });
                        calls.push({
                            value: underlying.weightedCalls,
                            data: underlying
                        });
                    }
                }

                $scope.openInterestChartData = [
                    {
                        key : "Put",
                        values : puts
                    },
                    {
                        key : "Call",
                        values : calls
                    }

                ];


            };

            function sectorName(code) {
                switch (code) {
                    case "00":
                        return "Not Applicable";
                    case "10":
                        return "Energy";
                    case "15":
                        return "Materials";
                    case "20":
                        return "Industrials";
                    case "25":
                        return "Retailing";
                    case "30":
                        return "Consumer Staples";
                    case "35":
                        return "Health Care";
                    case "40":
                        return "Financials";
                    case "45":
                        return "Information Technology";
                    case "50":
                        return "Telecommunication";
                    case "55":
                        return "Utilities";
                    case "99":
                        return "Classification Pending";
                }

            }
        }])

        .controller('wizard', ['$scope', function ($scope){
            $scope.submit = function (){
            };
            $scope.addNewStep = function (newStep){
                $scope.dynamicSteps.push(newStep);
            };

            $scope.dynamicSteps = ["step 3"];
            $scope.dynamicRequiredText = {};
        }]);


}
